export const PARENTAL_POLICY = [
    'Parents Only',
    'Parents (including in-laws)',
    'Parents OR parents-in-law',
    'Parents + Parents-in-law',
    'Parents OR parent-in-laws'
];
